import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7e16a6bedae70014ea6bcd_1788465497735_05857f1c/teitimeclock/src/app/kiosk-display/components/KioskDisplay.tsx");
